

    @if (!customizableMode) {
        <p-card>
        <div class="padding15" style="position:relative;" [class.module-mmc-double-view]="!singleWidth">
            <div *ngIf="ps.hasAnyRole(['ROLE_HIDE_MODEL_MARKET_CENTER']) || !ps.hasAnyRole(['ROLE_MODEL_SEC_MANAGER'])" style="
              position: absolute;
              top: 0;
              bottom: 0;
              width: 100%;
              opacity: 0.5;
              background-color: white;
              height: 100%;">
            </div>
            <div class="module-flex-row-with-space" style="padding: 0;">
                <div class="module-title">
                    <div class="module-title-label" >Model Market Center</div>
                    <img class="svg-arrow-right-circle" src="../../assets/images/arrow-right-circle-outline.svg" (click)="showModelMarketCenter()" style="height: 20px;">
                </div>
                @if (singleWidth) {
                    <div class="module-mmc-summary-billing-selector">
                        <mat-button-toggle-group as-button-group variation="primary" [(ngModel)]="selectedSection" (ngModelChange)="applySectionChange()">
                            <mat-button-toggle value="summary" checked>Summary</mat-button-toggle>
                            <mat-button-toggle value="billing">Billing</mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                }
            </div>

            @if (!data) {
                <div class='loading-spinner'></div>
            }

            @if (data) {
                <div [class.module-mmc-data-wrapper-double-view]="!singleWidth" [class.module-mmc-data-wrapper-single-view]="singleWidth">
                    @if (showSummaryBlock) {
                        <div class="module-mmc-summary-block">
                            @if (!singleWidth) {
                                <div class="bold" style="margin-bottom: 20px;font-size: 14px;">Summary</div>
                            }
                            <div style="display: flex;flex-direction: row;">
                                <div style="border-right: 1px solid #CBD1D6;width: 50%;padding-right: 15px;height: 164px;" class="module-mmc-summary-panel">
                                    <div class="module-mmc-summary-panel-block" style="border-bottom: 1px solid #CBD1D6;">
                                        <div class="module-flex-row-with-space" >AUM</div>
                                        <div class="modules-panel-number" >${{aumFormatted}}</div>
                                    </div>
                                    <div class="module-mmc-summary-panel-block" style="border-bottom: 1px solid #CBD1D6;">
                                        <div class="module-flex-row-with-space" style="padding-top:7px;">
                                            <div class="module-mmc-panel-label">Subscribed Models</div>
                                            <img class="svg-arrow-right-circle" src="../../assets/images/arrow-right-circle-outline.svg" (click)="showSubscribedModels()" >
                                        </div>
                                        <div  class="modules-panel-number" >{{data.subscribedModels}}</div>
                                    </div>
                                    <div class="module-mmc-summary-panel-block" >
                                        <div class="module-flex-row-with-space" style="padding-top:7px;">
                                            <div class="module-mmc-panel-label">Assigned Portfolios</div>
                                            <img class="svg-arrow-right-circle" src="../../assets/images/arrow-right-circle-outline.svg" (click)="showAssignedPortfolios()" >
                                        </div>
                                        <div  class="modules-panel-number" >{{data.assignedPortfolios || 0 | number}}</div>
                                    </div>
                                </div>

                                <div style="width: 50%;padding-left: 15px;" class="module-mmc-status-panel">
                                    <div class="module-mmc-status-panel-block" >
                                        <div class="module-flex-row-with-space">Status</div>
                                        <div  class="modules-panel-number">{{dateFromTimestamp}}</div>
                                    </div>

                                    @if (!data?.modelsPendingReview && !data?.modelsWithUnreadChanges) {
                                        <div class="module-mmc-summary-panel-block" style="border-top: 1px solid #CBD1D6;padding:10px 0;line-height: 20px;">
                                            No new changes to subscribed Model Market Center models
                                        </div>
                                    }

                                    @if (data?.modelsWithUnreadChanges) {
                                        <div class="module-mmc-summary-panel-block" style="border-top: 1px solid #CBD1D6;">
                                            <div class="module-flex-row-with-space" >
                                                <div>
                                                    <span class="modules-panel-number" >{{data.modelsWithUnreadChanges}}</span>
                                                    <span style="font-size: 14px;line-height: 20px;">Models with new changes</span>
                                                </div>
                                                <img class="svg-arrow-right-circle" src="../../assets/images/arrow-right-circle-outline.svg" (click)="showModelsWithUnreadChanges()" >
                                            </div>
                                        </div>
                                    }

                                    @if (data?.modelsPendingReview) {
                                        <div class="module-mmc-summary-panel-block" style="border-top: 1px solid #CBD1D6;">
                                            <div class="module-flex-row-with-space" >
                                                <div>
                                                    <span class="modules-panel-number" >{{data.modelsPendingReview || 0}}</span>
                                                    <span style="font-size: 14px;line-height: 20px;">Models with automated rebalancing paused for review</span>
                                                </div>
                                                <img class="svg-arrow-right-circle" src="../../assets/images/arrow-right-circle-outline.svg" (click)="showModelsPausedForReview()" >
                                            </div>
                                        </div>
                                    }

                                </div>
                            </div>
                        </div>
                    }

                    @if (showBillingBlock) {
                        <div class="module-mmc-billing-block">
                            @if (!singleWidth) {
                                <div class="bold" style="margin-bottom: 20px;font-size: 14px;">Billing</div>
                            }
                            <div style="display: flex;flex-direction: row;">
                                <div style="border-right: 1px dotted #CBD1D6;width: 50%;padding-right: 15px;height: 164px;" class="module-mmc-billing-panel-block">
                                        <div class="module-mmc-panel-label" style="padding-bottom: 7px;">Most Recent Billing Summary</div>

                                        @for (item of mmcMonthlyBillingSummaryRecent; track item.value; let i = $index) {
                                            <div class="module-mmc-billing-download-item" style="padding:7px 0;">
                                                <img src="../../assets/images/download006E99.svg"
                                                     (click)="viewMMCMonthlyBillingSummary(item.value)" style="margin-right: 7px;">
                                                <div style="display: inline-block;line-height: 16px;vertical-align: text-bottom;">{{item.name}}</div>
                                                @if (showBell && i === 0) {
                                                    <img src="../../assets/images/bell.svg" style="margin-left: 5px;vertical-align: top;">
                                                }
                                            </div>
                                        }
                                </div>
                                <div class="module-mmc-billing-panel-block" style="width: 50%;padding-left: 15px;">
                                    <div class="module-mmc-panel-label">Previous Months</div>
                                    <div class="module-mmc-billing-dd-item" style="padding:7px 0;">
                                        <irb-dropdown-filter #IrbDropdownPreviousMonths (search)="getPreviousMonths($event)" [size]="15"
                                                             [hoverPanelWidth]="150"
                                                             [value]="selectedMnthYr"
                                                             (selection)="onSelectMonthYear($event)"></irb-dropdown-filter>
                                        <div style="padding-top: 10px;">
                                            <button class='btn-medium-secondary' (click)="selectedMnthYrValue !== -1 && viewMMCMonthlyBillingSummary(selectedMnthYrValue)">Download</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    }
                </div>

                <div class="widget-footer">
                    <div class="refreshIcon" (click)="refreshWidgetData()"></div>
                    <div>
                        <span class="timestamp">Updated {{timeFromTimestamp}}, {{dateFromTimestamp}}</span>
                    </div>
                </div>
            }
        </div>
        </p-card>
    }
    @if (customizableMode) {
        <div style="padding:25px 10px;">
            <div style="display: flex;flex-direction: row;">
                <div [style.width.%]="singleWidth ? 50: 25" style="padding-right: 15px;">
                    <div class="skeleton-styles-rectangle" style="width: 40%;"></div>
                    <div class="skeleton-styles-rectangle" style="width: 50%;margin-top: 7px;"></div>
                    <div class="module-flex-row-with-space" style="margin-top:5px;">
                        <div class="skeleton-styles-rectangle" style="width: 90%;"></div>
                        <div class="skeleton-styles-circle"></div>
                    </div>
                    <div class="skeleton-styles-rectangle" style="width: 50%;margin-top: 7px;"></div>
                    <div class="module-flex-row-with-space" style="margin-top:5px;">
                        <div class="skeleton-styles-rectangle" style="width: 90%;"></div>
                        <div class="skeleton-styles-circle"></div>
                    </div>
                    <div class="skeleton-styles-rectangle" style="width: 50%;margin-top: 7px;"></div>
                </div>
                <div [style.width.%]="singleWidth ? 50: 25" style="padding-left: 15px;" >
                    <div class="skeleton-styles-rectangle" style="width: 45%;"></div>
                    <div class="skeleton-styles-rectangle" style="width: 55%;margin-top: 7px;"></div>
                    <div class="module-flex-row-with-space" style="margin-top:5px;">
                        <div class="skeleton-styles-rectangle" style="width: 90%;"></div>
                        <div class="skeleton-styles-circle"></div>
                    </div>
                    <div class="module-flex-row-with-space" style="margin-top:5px;">
                        <div class="skeleton-styles-rectangle" style="width: 90%;"></div>
                        <div class="skeleton-styles-circle"></div>
                    </div>
                </div>
                @if (!singleWidth) {
                    <div style="width:25%;padding:0 15px 0 30px;">
                        <div class="skeleton-styles-rectangle" style="width: 40%;"></div>
                        <div class="skeleton-styles-rectangle" style="width: 90%;margin-top: 7px;"></div>
                        <div style="margin-top: 7px;display: flex;flex-direction: row;">
                            <div class="skeleton-styles-rectangle" style="width: 16px; margin-right: 7px;"></div>
                            <div class="skeleton-styles-rectangle" style="width: 50%;"></div>
                        </div>
                        <div style="margin-top: 7px;display: flex;flex-direction: row;">
                            <div class="skeleton-styles-rectangle" style="width: 16px; margin-right: 7px;"></div>
                            <div class="skeleton-styles-rectangle" style="width: 50%;"></div>
                        </div>
                        <div style="margin-top: 7px;display: flex;flex-direction: row;">
                            <div class="skeleton-styles-rectangle" style="width: 16px; margin-right: 7px;"></div>
                            <div class="skeleton-styles-rectangle" style="width: 50%;"></div>
                        </div>
                        <div style="margin-top: 7px;display: flex;flex-direction: row;">
                            <div class="skeleton-styles-rectangle" style="width: 16px; margin-right: 7px;"></div>
                            <div class="skeleton-styles-rectangle" style="width: 50%;"></div>
                        </div>
                    </div>
                    <div style="width:25%;padding-left: 15px;">
                        <div class="skeleton-styles-rectangle" style="width: 60%;"></div>
                        <div class="skeleton-styles-rectangle" style="width: 80%;margin-top: 7px;height: 24px;"></div>
                        <div class="skeleton-styles-rectangle" style="width: 60%;margin-top: 7px;height: 20px;"></div>
                    </div>
                }

            </div>
        </div>
    }



